import { createContext } from "react";
import { Journey } from "./types";
import { ResourceState } from "Helpers/DataDefinitions/ResourceStates";

interface JourneyContextType {
  journey: Journey;
  setJourney: (journey: Journey) => void;
  loadingState: ResourceState;
}
export const JourneyContext = createContext<JourneyContextType>({
  journey: {},
  setJourney: () => {},
  loadingState: "UNLOADED",
});
